import { createFileRoute } from '@tanstack/react-router';
import { ConfirmUserPage } from '@/pages/confirm-user';

export const Route = createFileRoute('/verify-email')({
  component: ConfirmUserPage,
});
